module.exports = __webpack_public_path__ + "img/chadle_adv_17.afe71b37.png";